import { Typography, Button } from "antd";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AppState } from "store";
import { undoDeleteIssue, setModalName } from "store/actions";
import { ISSUE_TYPE } from "utils/mapped-data";

const { Text, Title } = Typography;

export default function UndoDeleteIssueForm() {
  const { selectedIssue } = useSelector<AppState, AppState["issues"]>(
    (state) => state.issues
  );
  const dispatch = useDispatch();
  const onCancel = useCallback(() => {
    dispatch(setModalName(undefined));
  }, [dispatch]);

  const onDelete = useCallback(() => {
    dispatch(undoDeleteIssue(selectedIssue?.id || ""));
    onCancel();
  }, [dispatch, onCancel, selectedIssue?.id]);

  return (
    <section className="undo-delete-modal">
      <Title level={5}>Re-Open Issue</Title>
      <Text type="secondary" className="description">
        Are you sure you want to re-open the archived issue{" "}
        <strong>
          “{selectedIssue?.serialId} : {ISSUE_TYPE[selectedIssue?.type || 0]}”
        </strong>{" "}
        ?
      </Text>
      <div className="action-btn-container">
        <Button className="cancel-btn" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="primary" danger onClick={onDelete}>
          Re-Open
        </Button>
      </div>
    </section>
  );
}
